export default "__VITE_ASSET__9a60a88c__"